export const defaultState = {} as const;

export function hiddenFeaturesReducer(state = defaultState) {
  return state;
}
